import { render, staticRenderFns } from "./SafeDuty.vue?vue&type=template&id=3473f322&scoped=true"
import script from "./SafeDuty.vue?vue&type=script&lang=js"
export * from "./SafeDuty.vue?vue&type=script&lang=js"
import style0 from "./SafeDuty.vue?vue&type=style&index=0&id=3473f322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3473f322",
  null
  
)

export default component.exports